export default {
  adapters: {
    breadcrumbs: {
      editorial: {
        home: 'Inicio'
      },
      ugr: {
        home: 'Inicio'
      },
      recipes: {
        home: 'Recetas'
      }
    },
    cards: {
      userCollection: {
        savedItemDescription_one: 'elemento',
        savedItemDescription_few: 'elementos',
        savedItemDescription_many: 'elementos',
        savedItemDescription_other: 'elementos',
        savedItemDescription: 'elemento',
        savedItemDescription_plural: 'elementos',
        savedItemDescription_0: 'elemento',
        savedItemDescription_1: 'elementos',
        savedItemDescription_2: 'elementos'
      },
      userRecipe: {
        statusTextDraft: 'Borrador de receta',
        statusApproved: 'Receta de usuario',
        statusPending: 'Esperando aprobación',
        statusRejected: 'Receta denegada'
      }
    },
    iconAdapter: {
      formatTimeHours_one: '{{hours}} h',
      formatTimeHours_few: '{{hours}} h',
      formatTimeHours_many: '{{hours}} h',
      formatTimeHours_other: '{{hours}} h',
      formatTimeHours: '{{hours}} h',
      formatTimeHours_plural: '{{hours}} h',
      formatTimeHours_0: '{{hours}} h',
      formatTimeHours_1: '{{hours}} h',
      formatTimeHours_2: '{{hours}} h',
      formatTimeMins_one: '{{minutes}} min',
      formatTimeMins_few: '{{minutes}} min',
      formatTimeMins_many: '{{minutes}} min',
      formatTimeMins_other: '{{minutes}} min',
      formatTimeMins: '{{minutes}} min',
      formatTimeMins_plural: '{{minutes}} min',
      formatTimeMins_0: '{{minutes}} min',
      formatTimeMins_1: '{{minutes}} min',
      formatTimeMins_2: '{{minutes}} min'
    },
    pageSchema: {
      editorial: {
        recipe: {
          calories: 'calorías',
          carbContent: 'gramos de hidratos de carbono',
          fatContent: 'gramos de grasa',
          fibreContent: 'gramos de fibra',
          proteinContent: 'gramos de proteínas',
          satFatContent: 'gramos de grasas saturadas',
          sodiumContent: 'miligramo de sodio',
          sugarContent: 'gramos de azúcar'
        }
      },
      ugr: {
        servesDefault: 'para'
      }
    },
    post: {
      ugr: {
        messageMember: 'Receta de usuario',
        messageOther: 'receta',
        statuses: {
          draft: 'Borrador  ',
          approved: 'Aprobada',
          rejected: 'descartada',
          pending: 'Pendiente',
          published: 'Publicada'
        }
      }
    },
    posts: {
      editorial: {
        list: {
          seeMoreText: 'Ver más'
        },
        liveBlog: {
          hour_one: 'hace 1 hora',
          hour_few: 'hace X horas',
          hour_many: 'hace X horas',
          hour_other: 'hace X horas',
          hour: 'hace 1 hora',
          hour_plural: 'hace X horas',
          hour_0: 'hace 1 hora',
          hour_1: 'hace X horas',
          hour_2: 'hace X horas',
          lessThanHour_one: 'hace 1 minuto',
          lessThanHour_few: 'hace X minutos',
          lessThanHour_many: 'hace X minutos',
          lessThanHour_other: 'hace X minutos',
          lessThanHour: 'hace 1 minuto',
          lessThanHour_plural: 'hace X minutos',
          lessThanHour_0: 'hace 1 minuto',
          lessThanHour_1: 'hace X minutos',
          lessThanHour_2: 'hace X minutos',
          lessThanMinute: 'hace menos de 1 minuto',
          updatedMessageLive: 'DIRECTO actualizado',
          updatedMessageNotLive: 'actualizado'
        }
      },
      postAdapter: {
        callout: 'Esto es {{status}} {{entity}}',
        previewCallout: 'Previsualización',
        recommendedTitle: 'Más contenido similar',
        statuses: {
          draft: 'borrador',
          approved: 'aprobado',
          rejected: 'descartado',
          pending: 'pendiente',
          preview: 'previsualización',
          published: 'publicado'
        },
        entities: {
          glossary: 'Glosario',
          howTo: 'Guías',
          editorialList: 'Lista editorial',
          plant: 'Planta',
          post: 'Publicación',
          recipe: 'Receta',
          review: 'Reseña',
          'broadcast-show': 'Lista editorial',
          venue: 'Lugares',
          page: 'Página',
          'user-collection': 'Colección de usuario',
          blog: 'Blog'
        }
      },
      recipeAdapter: {
        getPublicationMessage: 'Receta de',
        nutritionHighInPrefix: 'alto en',
        nutritionLabel: 'Valor nutricional',
        nutritionLowInPrefix: 'bajo en',
        planning: {
          'easily-doubled': 'Se duplica fácilmente',
          'easily-halved': 'Se divide fácilmente por dos',
          freezable: 'Congelable'
        },
        recommendedAltTitle: 'Nuestra alternativa más popular',
        servingsLabel: 'Para'
      },
      userRecipeAdapter: {
        categoryDisplay: 'Recetas'
      }
    },
    sponsorTracking: {
      label: 'Cooperación publicitaria'
    },
    pageBlocks: {
      riddle: {
        errorMessage: 'There seems to be an issue with the quiz, please try again.'
      }
    }
  },
  controllers: {
    search: {
      modifyFilterOptions: {
        transform: {
          time: {
            hour_one: '{{hours}} hora',
            hour_few: '{{hours}} horas',
            hour_many: '{{hours}} horas',
            hour_other: '{{hours}} horas',
            hour: '{{hours}} hora',
            hour_plural: '{{hours}} horas',
            hour_0: '{{hours}} hora',
            hour_1: '{{hours}} horas',
            hour_2: '{{hours}} horas',
            minute_one: '{{minutes}} minuto',
            minute_few: '{{minutes}} minutos',
            minute_many: '{{minutes}} minutos',
            minute_other: '{{minutes}} minutos',
            minute: '{{minutes}} minuto',
            minute_plural: '{{minutes}} minutos',
            minute_0: '{{minutes}} minuto',
            minute_1: '{{minutes}} minutos',
            minute_2: '{{minutes}} minutos',
            gte: '{{time}} o más',
            gt: 'Más de {{time}}',
            lte: '{{time}} o menos',
            lt: 'Menos de {{time}}'
          },
          calories: {
            gteOrGt: 'Más de {{calories}} kcal',
            lteOrLt: 'Hasta {{calories}} kcal'
          }
        }
      },
      siteSearchConfig: {
        facet: {
          label: {
            author: 'Autor',
            calories: 'Calorías',
            category: 'Categoría',
            cuisine: 'Cocina',
            diet: 'Dieta',
            difficulty: 'Dificultad',
            mealType: 'Comida',
            occasion: 'Ocasión',
            ratings: 'Valoración',
            servings: 'Raciones',
            totalTime: 'Tiempo total'
          }
        },
        filter: {
          label: {
            recipe: 'Recetas',
            video: 'Video',
            guides: 'Guías',
            collection: 'Colección de recetas',
            glossary: 'Glosario',
            review: 'Reseñas'
          }
        },
        sortOptions: {
          label: {
            published: 'Más recientes',
            quickest: 'Más rápidas',
            rating: 'Más populares',
            relevant: 'Más relevantes'
          }
        }
      }
    }
  }
};